import styled from 'styled-components';

export const StyledBookingFormWrapper = styled.div<{ $opened: boolean }>`
  display: flex;
  flex-direction: row;
  flex: 1;
  gap: 1rem;
  width: 100%;
  flex-wrap: wrap;
  max-height: ${(props) => (props.$opened ? '100vw' : '0')};
  overflow: hidden;
  transition: max-height 1.5s ease-out;
`;

export const StyledBookingItem = styled.div`
  gap: 0.5rem;
  flex: 1;
  align-self: flex-end;
  min-width: 250px;
  display: flex;
  flex-direction: column;
`;

export const StyledBookingLabelAndPrice = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 0.5rem;
  padding-right: 0.25rem;
`;
